import React, {useState, useEffect} from 'react';
import { Box } from '@mui/material';
import backend from "../backend";
import DataTable from 'react-data-table-component';
import { getNumSort } from 'utils';

const AdminVideos: React.FC = () => {
  const [videoStats, setVideoStats] = useState<any[]>([]);  

  async function loadVideoStats() {
    const data = await backend.video_stats();
    setVideoStats(data);
  }

  useEffect(() => {
    loadVideoStats()
  },[])


  return (
    <Box sx={{ p: 2 }}>
             <DataTable data={videoStats} 
                        keyField="uid" striped highlightOnHover 
                        defaultSortField="uid" 
                        progressPending={videoStats.length===0}
                        columns={[
                          {name: 'ID',  selector: 'uid',  sortable: true, width: "80px"},
                          {name: 'email', selector: 'email', grow:2, sortable: true },
                          {name: 'name', selector: 'name', grow:2, sortable: true },
                          {name: 'group', selector: 'group',   sortable: true },
                          {name: '# total annotations', selector: 'ann', sortable: true  , sortFunction:getNumSort("ann")},
                        //    {
                        //      name: 'Browse', width: "80px",compact:true,
                        //      cell: (row:any) =>  <Link to={`/ann?user=${row.email}`}>
                        //                                            <AiOutlineMonitor data-tip="browse"/> 
                        //                                          </Link>,
                        //    }
                   ]}/>
 
    </Box>
  );
};

export default AdminVideos;
